import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { getEntities } from "../../api/entities";
import EntitiesTable from "../../components/Entities/EntitiesTable";
import { useErrorHandler } from "../../hooks/Error/useErrorHandler";
import { useAccountPermissions } from "../../hooks/Permissions/useAccountPermissions";
import { setLoading } from "../../store/UI";
import { Entity } from "../../types/model/entity/Entity";

const ListEntities = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleError = useErrorHandler();
  const { isEntityAccount } = useAccountPermissions();

  const [entities, setEntities] = React.useState<Entity[]>([]);

  const refreshData = async () => {
    dispatch(setLoading(true));

    try {
      const response = await getEntities();
      setEntities(response);
    } catch (error) {
      handleError(error);
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    const loadInitialEntities = async () => {
      if (!isEntityAccount) {
        await refreshData();
        return;
      }

      dispatch(setLoading(true));

      try {
        const response = await getEntities();
        if (response.length > 0) {
          navigate(`/entities/${response[0].id}`);
        }
      } catch (error) {
        handleError(error);
      } finally {
        dispatch(setLoading(false));
      }
    };

    loadInitialEntities();
  }, []);

  return (
    <div>
      <EntitiesTable
        tableData={entities}
        onRequestRefresh={refreshData}
        showAddButton={true}
      />
    </div>
  );
};

export default ListEntities;